/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Vchip_LanguageInputs */



/**
* | output |
* | --- |
* | "Adult Language" |
*
* @param {Subtitle_Export_Vchip_LanguageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_vchip_language = /** @type {((inputs?: Subtitle_Export_Vchip_LanguageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Vchip_LanguageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Langage adulte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erwachsenensprache")
	if (locale === "it") return /** @type {LocalizedString} */ ("Linguaggio per adulti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Язык взрослых")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lenguaje adulto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("成人语言")
	if (locale === "ja") return /** @type {LocalizedString} */ ("大人向けの言葉遣い")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वयस्क भाषा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Linguagem adulta")
	return /** @type {LocalizedString} */ ("Adult Language")
});